
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import WaitlistForm from "@/components/landing/WaitlistForm";

export default function Register() {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(true);

  const handleSuccess = () => {
    // Optionally navigate to a thank you page or back to home
    setTimeout(() => navigate('/'), 2000);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="container px-4 md:px-6 py-8">
        <Button
          variant="ghost"
          size="sm"
          className="mb-6"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-md border border-gray-100">
          <div className="mb-8 flex justify-center">
            <img 
              src="/lovable-uploads/1268e013-62c0-4efc-98ef-21ea816431fb.png" 
              alt="Standardly Logo" 
              className="h-10 w-auto" 
            />
          </div>
          
          <h1 className="text-2xl font-bold text-center mb-2">Join Our Waitlist</h1>
          <p className="text-center text-muted-foreground mb-8">
            Be the first to experience Standardly when we launch
          </p>
          
          {showForm && <WaitlistForm onSuccess={handleSuccess} />}
          
          <p className="text-xs text-center text-muted-foreground mt-6">
            By joining our waitlist, you agree to our{" "}
            <a href="#" className="text-primary hover:underline">Terms of Service</a> and{" "}
            <a href="#" className="text-primary hover:underline">Privacy Policy</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
